import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentAge: "18",
  retirementAge: "58",
  contributionYears: "40",
  monthlyContribution: "1000",
  annualIncrease: "2",
  expectedReturn: "10",
  annuityInvestment: "56",
  annuityRate: "7",
  pensionErrors: null,
  monthlyPension: 0,
  calculationResults: {
    totalInvestment: 0,
    totalCorpus: 0,
    interestEarned: 0,
    totalTaxSaving: 0,
    annuityValue: 0,
    lumpsumWithdrawal: 0
  }
};

const pensionSlice = createSlice({
  name: "pensionCalculator",
  initialState: initialState,

  reducers: {
    setCurrentAge: (state, action) => {
      state.currentAge = action.payload;
    },
    setRetirementAge: (state, action) => {
      state.retirementAge = action.payload;
    },
    setContributionYears: (state, action) => {
      state.contributionYears = action.payload;
    },
    setMonthlyContribution: (state, action) => {
      state.monthlyContribution = action.payload;
    },
    setAnnualIncrease: (state, action) => {
      state.annualIncrease = action.payload;
    },
    setExpectedReturn: (state, action) => {
      state.expectedReturn = action.payload;
    },
    setAnnuityInvestment: (state, action) => {
      state.annuityInvestment = action.payload;
    },
    setAnnuityRate: (state, action) => {
      state.annuityRate = action.payload;
    },
    setPensionResult: (state, action) => {
      state.pensionResult = action.payload;
    },
    setMonthlyPension: (state, action) => {
        state.monthlyPension = action.payload;
      },
      setCalculationResults: (state, action) => {
        state.calculationResults = action.payload;
      },
      setTotalTaxSaving: (state, action) => {
        state.totalTaxSaving = action.payload;
      },
       setPensionErrors: (state, action) => {
            state.pensionErrors = action.payload;
          },
 resetPentionData: (state) => {
      return initialState;
    },
  }
});

export const { 
  setCurrentAge, 
  setRetirementAge, 
  setContributionYears, 
  setMonthlyContribution,
  setAnnualIncrease,
  setExpectedReturn,
  setAnnuityInvestment,
  setAnnuityRate,
  setPensionResult ,
  setMonthlyPension,
  setCalculationResults,
  setTotalTaxSaving,resetPentionData,
  setPensionErrors
} = pensionSlice.actions;

export default pensionSlice.reducer;